module.exports = __webpack_public_path__ + "img/girl.52e84c4d.jpg";